export default "__VITE_ASSET__CfSHnH0r__"